"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canadianCitiesLabelOnly = exports.canadianCities = void 0;
const alberta_cities_1 = require("./alberta-cities");
const british_colombia_cities_1 = require("./british-colombia-cities");
const manitoba_cities_1 = require("./manitoba-cities");
const new_brunswick_cities_1 = require("./new-brunswick-cities");
const newfoundland_cities_1 = require("./newfoundland-cities");
const northwest_territory_cities_1 = require("./northwest-territory-cities");
const nova_scotia_cities_1 = require("./nova-scotia-cities");
const nunavut_cities_1 = require("./nunavut-cities");
const ontario_cities_1 = require("./ontario-cities");
const prince_edward_island_cities_1 = require("./prince-edward-island-cities");
const quebec_cities_1 = require("./quebec-cities");
const saskatchewan_cities_1 = require("./saskatchewan-cities");
const yukon_cities_1 = require("./yukon-cities");
const formatOptionsLabel = (options) => {
    return options.map((option) => {
        return {
            option: option.label,
        };
    });
};
exports.canadianCities = {
    alberta: alberta_cities_1.albertaCities,
    britishColumbia: british_colombia_cities_1.britishColombiaCities,
    manitoba: manitoba_cities_1.manitobaCities,
    newBrunswick: new_brunswick_cities_1.newBrunswickCities,
    newfoundland: newfoundland_cities_1.newfoundlandCities,
    northwestTerritories: northwest_territory_cities_1.northwestTerritoriesCities,
    novaScotia: nova_scotia_cities_1.novaScotiaCities,
    nunavut: nunavut_cities_1.nunavutCities,
    ontario: ontario_cities_1.ontarioCities,
    princeEdwardIsland: prince_edward_island_cities_1.princeEdwardIslandCities,
    quebec: quebec_cities_1.quebecCities,
    saskatchewan: saskatchewan_cities_1.saskatchewanCities,
    yukon: yukon_cities_1.yukonCities,
};
exports.canadianCitiesLabelOnly = {
    alberta: formatOptionsLabel(alberta_cities_1.albertaCities),
    britishColumbia: formatOptionsLabel(british_colombia_cities_1.britishColombiaCities),
    manitoba: formatOptionsLabel(manitoba_cities_1.manitobaCities),
    newBrunswick: formatOptionsLabel(new_brunswick_cities_1.newBrunswickCities),
    newfoundland: formatOptionsLabel(newfoundland_cities_1.newfoundlandCities),
    northwestTerritories: formatOptionsLabel(northwest_territory_cities_1.northwestTerritoriesCities),
    novaScotia: formatOptionsLabel(nova_scotia_cities_1.novaScotiaCities),
    nunavut: formatOptionsLabel(nunavut_cities_1.nunavutCities),
    ontario: formatOptionsLabel(ontario_cities_1.ontarioCities),
    princeEdwardIsland: formatOptionsLabel(prince_edward_island_cities_1.princeEdwardIslandCities),
    quebec: formatOptionsLabel(quebec_cities_1.quebecCities),
    saskatchewan: formatOptionsLabel(saskatchewan_cities_1.saskatchewanCities),
    yukon: formatOptionsLabel(yukon_cities_1.yukonCities),
};
